import * as com from "../../Common.js"
export function getDTI (application, activeTab, type) {
    function calculateTotalIncome (grossIncomeList) {
        if(activeTab === 'all'){
            let noRepeatList = [];
            grossIncomeList.forEach((item) => {
                if (item.title === 'Rental Income') {
                    let priceList = item.priceList.filter((item) => !item.isRepeat)
                    noRepeatList.push({
                        ...item,
                        price: item.priceList.filter((item) => !item.isRepeat).reduce((sum, item) => sum + item.price, 0),
                        priceList
                    })
                }else{
                    noRepeatList.push(item)
                    }
                });
                return noRepeatList
        }else{
            return grossIncomeList
        }
    }

    function processIncomeData (borrower, coborrower, hasCoborrower) {
        const processOccupation = (occupation, from, href) => {
            const title = occupation.selfemployed ? 'Self-employment' : 'Employment';
      
            const priceList = occupation.selfemployed ? [
                {
                    title: 'Monthly income',
                    price: parseFloat(occupation.incomeorloss) || 0,
                },
                {
                    title: 'Ownership share',
                    price: parseFloat(occupation.percentownership) || 0,
                    type: 'percent'
                },
            ] : [
                {
                    title: 'Base Employment Income',
                    price: parseFloat(occupation.income.base) || 0,
                },
                {
                    title: 'Overtime',
                    price: parseFloat(occupation.income.overtime) || 0,
                },
                {
                    title: 'Bonuses and Commissions',
                    price:
                        (parseFloat(occupation.income.bonuses) || 0) +
                        (parseFloat(occupation.income.commissions) || 0),
                },
                {
                    title: 'Military entitlements',
                    price: parseFloat(occupation.income.military) || 0,
                },
                {
                    title: 'Other',
                    price: parseFloat(occupation.income.other) || 0,
                },
            ]
      
            const totalPrice = occupation.selfemployed ? (parseFloat(occupation.incomeorloss) || 0) : priceList.reduce((sum, item) => sum + item.price, 0)
      
            return {
                title,
                from,
                href,
                employername: occupation.employername || '',
                price: totalPrice,
                priceList,
            }
        }
      
        function processAllOccupations (occupations, from, href) {
            return occupations.map((occupation) => processOccupation(occupation, from, href))
        }
        
        function processIncome (income, from, href) {
            if (!income) return []
            const formatTitle = (key) => {
                const item = com.othersouresofincome.find(([firstValue]) => firstValue === key)
                return item ? item[1] : null
            }
            const priceList = (income.otherincome || []).map((item) => ({
                title: formatTitle(item.incometype),
                price: parseFloat(item.amount) || 0,
            }))
      
            const totalPrice = priceList.reduce((sum, item) => sum + item.price, 0)
      
            return [{
                title: 'Income from other sources',
                from,
                href,
                employername: '',
                price: totalPrice,
                priceList,
            }]
        }

        function processRentalIncome (from, href) {
            const purpose = application.property.purpose;
            let priceList = []
            const borrowerObj = from === 'borrower' ? application.borrower : application.coborrower
            const calculateRepeat = (coborrowerData, borrowerData) => {
                // console.log('check: ', coborrowerData, borrowerData)
                if(coborrowerData.occupancy === "investment" || coborrowerData.propertytype === "twotofour"){
                        const data = borrowerData.find((item) => (item.occupancy === "investment" || item.propertytype === "twotofour") && coborrowerData.address === item.address)
                        return data ? true : false
                }else{
                    return false
                }
            }
            if(purpose !== 'purchase'){
                priceList = [application.property, ...borrowerObj.ownedproperties]?.map((item, index) => ({
                    title: index > 2 ? `Extra Property ${index - 2}` : `Property (3${index === 0 ? 'a' : (index === 1 ? 'b' : 'c')})`,
                    price: parseFloat(item.grossrentalincome) || 0,
                    isRepeat: activeTab === 'all' && from === 'coborrower' ? calculateRepeat(item, [...application.borrower.ownedproperties, application.property]) : false,
                }))
            } else {
                priceList = borrowerObj.ownedproperties?.map((item, index) => ({
                    title: index > 2 ? `Extra Property ${index - 2}` : `Property (3${index === 0 ? 'a' : (index === 1 ? 'b' : 'c')})`,
                    price: parseFloat(item.grossrentalincome) || 0,
                    isRepeat: activeTab === 'all' && from === 'coborrower' ? calculateRepeat(item, [...application.borrower.ownedproperties, application.property]) : false,
                }))
                if (application.property.propertytype === "twotofourfamily" || application.property.occupancy === "investment") {
                    priceList.push({
                        title: 'Property (4c)',
                        price: parseFloat(application.property.purchase.expectedgrossmonthlyrentalincome) || 0,
                        isRepeat: false,
                    })
                }
            }
            return [{
                title: 'Rental Income',
                from,
                href: priceList.length === 1 && priceList[0].title.includes('4c') ? '#4c' : href,
                employername: '',
                price: priceList.reduce((sum, item) => sum + item.price, 0),
                priceList,
            }]
        }
        const borrowerData = [
            ...processAllOccupations([borrower.occupation], 'borrower', '#1b'),
            ...processAllOccupations(borrower.otheroccupations || [], 'borrower', '#1c'),
            ...processIncome(borrower.income, 'borrower', '#1e'),
            ...processRentalIncome('borrower', '#3a'),
        ]
      
        const coborrowerData = hasCoborrower === 'withcoborrower' ? [
            ...processAllOccupations([coborrower.occupation], 'coborrower', '#1b'),
            ...processAllOccupations(coborrower.otheroccupations || [], 'coborrower', '#1c'),
            ...processIncome(coborrower.income, 'coborrower', '#1e'),
            ...processRentalIncome('coborrower', '#3a'),
        ] : []
      
        return [...borrowerData, ...coborrowerData]
    }

    function processLiabilityData (borrower, coborrower, hasCoborrower, loanList, newLoanList) {
        function isAllLoansPayoff (item) {
            return item.loans.length > 0 && item.loans.every(loan => loan.paidoffatclosing === "yes")
        }
        function expense (data) {
            return data.reduce((sum, item, index) => {
                
                if (item.status === "sold" || (item.status === "pending" && isAllLoansPayoff(item))) {
                    return sum
                }
    
                if (index === 0) {
                    if (application.borrower.presentaddressownership === "own" && 
                        application.property.purpose === "refinance" &&
                        (item.occupancy === "investment" || item.occupancy === "secondhome")) {
                        const loanPayments = item.loans.reduce((loanSum, loan) => {
                            if (loan.paidoffatclosing === "yes") {
                                return loanSum
                            }
                            const loanPayment = isNaN(Number(loan.monthlypayment)) ? 0 : Number(loan.monthlypayment)
                            return loanSum + loanPayment
                        }, 0)
                        return isNaN(Number(item.insurancemaintenancetaxes)) ? 0 : Number(item.insurancemaintenancetaxes) + loanPayments
                    }
                    
                    if (item.occupancy === "principal" && 
                        (item.status === "pending" || (item.status === "sold" && isAllLoansPayoff(item))) && 
                        application.property.purpose === "purchase" && 
                        application.property.occupancy === "principal") {
                        return sum
                    }
                }
        
                if (application.borrower.presentaddressownership === "own" && 
                    application.property.purpose === "refinance" &&
                    index > 0 && 
                    data.length > 0 && 
                    (data[0].occupancy === "investment" || data[0].occupancy === "secondhome")) {
                    // if (item.occupancy !== "principal") {
                    //     return sum
                    // }
                }
        
                const taxes = isNaN(Number(item.insurancemaintenancetaxes)) ? 0 : Number(item.insurancemaintenancetaxes)
                const loanPayments = item.loans.reduce((loanSum, loan) => {
                    if (loan.paidoffatclosing === "yes") {
                        return loanSum
                    }
                    const loanPayment = isNaN(Number(loan.monthlypayment)) ? 0 : Number(loan.monthlypayment)
                    return loanSum + loanPayment
                }, 0)
                return sum + taxes + loanPayments
            }, 0)
        }
        function totalExpense (borrowerProperties, coborrowerProperties) {
            const borrowerSum = borrowerProperties.reduce((sum, item, index) => {
    
                if (item.status === "sold" || (item.status === "pending" && isAllLoansPayoff(item))) {
                    return sum
                }
    
                if (index === 0) {
                    if (application.borrower.presentaddressownership === "own" && 
                        application.property.purpose === "refinance" &&
                        (item.occupancy === "investment" || item.occupancy === "secondhome")) {
                        const loanPayments = item.loans.reduce((loanSum, loan) => {
                            if (loan.paidoffatclosing === "yes") {
                                return loanSum
                            }
                            const loanPayment = isNaN(Number(loan.monthlypayment)) ? 0 : Number(loan.monthlypayment)
                            return loanSum + loanPayment
                        }, 0)
                        return isNaN(Number(item.insurancemaintenancetaxes)) ? 0 : Number(item.insurancemaintenancetaxes) + loanPayments
                    }
        
                    if (item.occupancy === "principal" && 
                        (item.status === "pending" || (item.status === "sold" && isAllLoansPayoff(item))) && 
                        application.property.purpose === "purchase" && 
                        application.property.occupancy === "principal") {
                        return sum
                    }
                }
        
                if (application.borrower.presentaddressownership === "own" && 
                    application.property.purpose === "refinance" &&
                    index > 0 && 
                    (borrowerProperties[0].occupancy === "investment" || borrowerProperties[0].occupancy === "secondhome")) {
                    // if (item.occupancy !== "principal") {
                    //     return sum
                    // }
                }
        
                const taxes = isNaN(Number(item.insurancemaintenancetaxes)) ? 0 : Number(item.insurancemaintenancetaxes)
                const loanPayments = item.loans.reduce((loanSum, loan) => {
                    if (loan.paidoffatclosing === "yes") {
                        return loanSum
                    }
                    const loanPayment = isNaN(Number(loan.monthlypayment)) ? 0 : Number(loan.monthlypayment)
                    return loanSum + loanPayment
                }, 0)
                return sum + taxes + loanPayments
            }, 0)
    
            const coborrowerSum = coborrowerProperties.reduce((sum, item, index) => {
    
                if (item.status === "sold" || (item.status === "pending" && isAllLoansPayoff(item))) {
                    return sum
                }
    
                if (application.borrower.presentaddressownership === "own" && 
                    application.property.purpose === "refinance" &&
                    borrowerProperties[0] && borrowerProperties[0].occupancy && 
                    (borrowerProperties[0].occupancy === "investment" || borrowerProperties[0].occupancy === "secondhome")) {
                    if (!item.occupancy || item.occupancy !== "principal") {
                        return sum
                    }
                }
        
                const matchingBorrowerItem = borrowerProperties.find(borrowerItem => borrowerItem.address === item.address)
                const taxes = matchingBorrowerItem ? 0 : (isNaN(Number(item.insurancemaintenancetaxes)) ? 0 : Number(item.insurancemaintenancetaxes))
                const loanPayments = item.loans.reduce((loanSum, loan) => {
                    if (loan.paidoffatclosing === "yes") {
                        return loanSum
                    }
                    const matchingLoan = matchingBorrowerItem ? matchingBorrowerItem.loans.find(borrowerLoan => borrowerLoan.accountnumber === loan.accountnumber) : null
                    const loanPayment = matchingLoan ? 0 : (isNaN(Number(loan.monthlypayment)) ? 0 : Number(loan.monthlypayment))
                    return loanSum + loanPayment
                }, 0)
                return sum + taxes + loanPayments
            }, 0)
    
            return borrowerSum + coborrowerSum
        }
        function currentMortgagePayment () {
            let price = 0
            const ownedproperties = application.borrower.ownedproperties || []
            const coborrowerOwnedproperties = application.hascoborrower === "withcoborrower" ? (application.coborrower.ownedproperties || []) : [] 
            if (application.property.purpose === "purchase") {
                if (activeTab === 'all') {
                    price = totalExpense(ownedproperties.slice(0, 1), coborrowerOwnedproperties.slice(0, 1))
                } else if (activeTab === 'borrower') {
                    price = expense(ownedproperties.slice(0, 1))
                } else {
                    price = expense(coborrowerOwnedproperties.slice(0, 1))
                }
            } else {
                price = 0
            }
            return price
        }
        function housingExpenses () {
            const priceList = []

            const ownedproperties = application.property.purpose === "purchase" ? (application.borrower.ownedproperties || []).slice(1) : application.borrower.ownedproperties || []
            const coborrowerOwnedproperties = application.hascoborrower === "withcoborrower"
                ? (application.property.purpose === "purchase" 
                    ? (application.coborrower.ownedproperties || []).slice(1) 
                    : (application.coborrower.ownedproperties || []))
                : []
            let price = currentMortgagePayment()
            if (application.borrower.presentaddressownership === "rent" && 
                !(application.borrower.presentaddressownership === "rent" && 
                application.property.purpose === "purchase" && 
                application.property.occupancy === "principal")) {
                const currentRent = parseFloat(application.borrower.expenses.currentrent) || 0
                price += currentRent
            }
            if (application.hascoborrower === "withcoborrower" && application.coborrower.presentaddressownership === "rent" && application.coborrower.presentaddressstreet !== application.borrower.presentaddressstreet) {
                const currentRent = parseFloat(application.coborrower.expenses.currentrent) || 0
                price += currentRent
            }
            if (application.property.purpose !== "purchase") {
                price += parseFloat(application.property.insurancemaintenancetaxes) || 0 
            }
            priceList.push({
                title: 'Current Mortgage Payment or Rent',
                price: price
            })
            if (!(application.borrower.presentaddressownership === "rent" && application.property.purpose === "purchase" && application.property.occupancy === "investment")) {
                priceList.push({
                    title: 'Proposed Mortgage Payment',
                    price: parseFloat(application.selection.selectedloan.monthly_payment) || parseFloat(application?.dtiCalculation?.monthlyPayment) || 0,
                })
            }
            let totalHousingExpense = 0
            if (activeTab === 'all') {
                totalHousingExpense = totalExpense(ownedproperties, coborrowerOwnedproperties)
            } else if (activeTab === 'borrower') {
                totalHousingExpense = expense(ownedproperties)
            } else {
                totalHousingExpense = expense(coborrowerOwnedproperties)
            }
            if (application.property.isManufacturedHome === true) {
                const spaceRent = parseFloat(application.property.mobilehomeinfo.leasedSpaceRentAmount) || 0
                totalHousingExpense += spaceRent
            }
            priceList.push({
                title: 'Additional Housing Expense',
                price: totalHousingExpense,
            })
            const totalPrice = priceList.reduce((sum, item) => sum + item.price, 0)
          
            return [
                {
                    title: 'Housing Expenses',
                    from: 'all',
                    href: '#3a',
                    type: 'dti',
                    employername: '',
                    price: totalPrice,
                    priceList,
                },
            ]
        }

        function getAmount () {
            let amount = 0
            const data = application.borrower.ownedproperties || []
            amount = data.filter(item => item.occupancy === "principal")
            .reduce((sum, item) => {
                const insurancemaintenancetaxes = parseFloat(item.insurancemaintenancetaxes) || 0
                const loansSum = item.loans.reduce((loanSum, loan) => {
                    if (loan.paidoffatclosing === "yes") {
                        return loanSum
                    }
                    const monthlypayment = parseFloat(loan.monthlypayment) || 0
                    return loanSum + monthlypayment
                }, 0)
                return sum + insurancemaintenancetaxes + loansSum
            }, 0)
            return amount
        }

        function frontDtiHousingExpenses () {
            let priceList = []        

            const from = activeTab === 'coborrower' ? 'coborrower' : 'borrower'
            if ((application.property.purpose === "purchase" || application.property.purpose === "refinance") && application.property.occupancy === "secondhome") {
                const data = application[from].ownedproperties || []
                let amount = data.filter(item => item.occupancy === "principal")
                .reduce((sum, item) => {
                    const insurancemaintenancetaxes = parseFloat(item.insurancemaintenancetaxes) || 0
                    const loansSum = item.loans.reduce((loanSum, loan) => {
                        if (loan.paidoffatclosing === "yes") {
                            return loanSum
                        }
                        const monthlypayment = parseFloat(loan.monthlypayment) || 0
                        return loanSum + monthlypayment
                    }, 0)
                    return sum + insurancemaintenancetaxes + loansSum
                }, 0)
                priceList = [
                    {
                        title: 'Current Mortgage Payment or Rent',
                        price: amount,
                    },
                    {
                        title: 'Proposed Mortgage Payment',
                        price: 0,
                    },
                    {
                        title: 'Additional Housing Expense',
                        price: 0,
                    }
                ]
            } else if (application.property.purpose === "refinance" && application.property.occupancy === "investment") {
                if (application.borrower.presentaddressownership === 'rent') {
                    priceList = [
                        {
                            title: 'Current Mortgage Payment or Rent',
                            price: getAmount() + (parseFloat(application[from].expenses.currentrent) || 0),
                        },
                        {
                            title: 'Proposed Mortgage Payment',
                            price: 0,
                        },
                        {
                            title: 'Additional Housing Expense',
                            price: 0,
                        }
                    ]
                } else {
                    priceList = [
                        {
                            title: 'Current Mortgage Payment or Rent',
                            price: getAmount(),
                        },
                        {
                            title: 'Proposed Mortgage Payment',
                            price: 0,
                        },
                        {
                            title: 'Additional Housing Expense',
                            price: 0,
                        }
                    ]
                }
            } else if (application.property.purpose === "purchase" && application.property.occupancy === "investment" && application.borrower.presentaddressownership === 'rent') {
                priceList = [
                    {
                        title: 'Current Mortgage Payment or Rent',
                        price: 0,
                    },
                    {
                        title: 'Proposed Mortgage Payment',
                        price: 0,
                    },
                    {
                        title: 'Additional Housing Expense',
                        price: 0,
                    }
                ] 
            } else {
                priceList = [
                    {
                        title: 'Current Mortgage Payment or Rent',
                        price: application.property.purpose === "purchase" ? 0 : (parseFloat(application.property.insurancemaintenancetaxes) || 0),
                    },
                    {
                        title: 'Proposed Mortgage Payment',
                        price: parseFloat(application.selection.selectedloan.monthly_payment) || parseFloat(application?.dtiCalculation?.monthlyPayment) || 0,
                    },
                    {
                        title: 'Additional Housing Expense',
                        price: 0,
                    }
                ]
            }
            if (application.property.isManufacturedHome === true) {
                const spaceRent = parseFloat(application.property.mobilehomeinfo.leasedSpaceRentAmount) || 0
                priceList = priceList.map(item => {
                    if (item.title === 'Additional Housing Expense') {
                        return {
                            ...item,
                            price: item.price + spaceRent
                        }
                    }
                    return item
                })
            }
            const totalPrice = priceList.reduce((sum, item) => sum + item.price, 0)
            return [
                {
                    title: 'Housing Expenses',
                    from: 'all',
                    href: '#3a',
                    type: 'frontDti',
                    employername: '',
                    price: totalPrice,
                    priceList,
                },
            ]
        }
        function otherLiability (liability, from, href) {
            if (!liability) return []
            const data = [
                ["alimony", "Alimony Payments"],
                ["childsupport", "Child Support Payments"],
                ["maintenancepayments", "Separate Maintenance Payments"],
                ["jobrelatedexpenses", "Job-Related Expenses"],
                ["other", "Other"],
            ]
            const formatTitle = (key) => {
                const item = data.find(([firstValue]) => firstValue === key)
                return item ? item[1] : null
            }
            const priceList = (liability.alimony || []).map((item) => ({
                title: formatTitle(item.alimonyorsupport),
                price: parseFloat(item.amount) || 0,
            }))
        
            const totalPrice = priceList.reduce((sum, item) => sum + item.price, 0)
        
            return [{
                title: 'Other Liability',
                from,
                href,
                employername: '',
                price: totalPrice,
                priceList,
            }]
        }
        function installmentLoans (loans) {
            if (!loans || loans.length === 0) return []
        
            const filteredLoans = loans.filter((item) => {
                // 基础条件
                const validPayment = parseFloat(item.monthlypayment) > 0
                const validBalance = parseFloat(item.remainingbalance) > 0
                const notPaidOff = item.paidoffatclosing !== 'yes'
        
                // 额外条件：根据 activeTab 过滤 ownership
                if (activeTab === 'borrower' && item.creditliabilityShownOwnershipType === 'CoBorrower') {
                    return false
                }
                if (activeTab === 'coborrower' && item.creditliabilityShownOwnershipType === 'Borrower') {
                    return false
                }
        
                return validPayment && validBalance && notPaidOff
            })
        
            if (filteredLoans.length === 0) return []

            const priceList = filteredLoans.map((item) => ({
                title: item.name,
                price: parseFloat(item.monthlypayment) || 0,
            }))
          
            const totalPrice = priceList.reduce((sum, item) => sum + item.price, 0)
          
            return [
                {
                    title: 'Installment Loans',
                    from: 'all',
                    href: '#2c',
                    employername: '',
                    price: totalPrice,
                    priceList,
                },
            ]
        }
        function estateLiablities (loans) {
            if (!loans || loans.length === 0) return []

            const priceList = loans.map((item) => ({
                title: item.creditor,
                price: parseFloat(item.monthlyamount) || 0,
            }))
          
            const totalPrice = priceList.reduce((sum, item) => sum + item.price, 0)
          
            return [
                {
                    title: 'Other Real Estate Liablities',
                    from: 'all',
                    href: '#4b',
                    employername: '',
                    price: totalPrice,
                    priceList,
                },
            ]
        }
        const borrowerData = [
            ...housingExpenses(),
            ...frontDtiHousingExpenses(),
            ...otherLiability(borrower.finances, 'borrower', '#2d'),
            ...installmentLoans(loanList),
            ...estateLiablities(newLoanList)
          ]
        
          const coborrowerData = hasCoborrower === 'withcoborrower' ? [
            ...otherLiability(coborrower.finances, 'coborrower', '#2d')
          ] : []
        
          return [...borrowerData, ...coborrowerData]
    }
    // 4. 计算 DTI
    const { borrower, coborrower, hascoborrower } = application;
    const { loans, newloans } = application.assetsandliabilities;
    const grossIncomeList = processIncomeData(borrower, coborrower, hascoborrower);
    const liabilityList = processLiabilityData(borrower, coborrower, hascoborrower, loans, newloans);
    if (type === 'income') {
        return calculateTotalIncome(grossIncomeList)
            .filter(item => activeTab === 'all' || item.from === 'all')
            .reduce((sum, item) => sum + item.price, 0);
    } else if (type === 'liability') {
        return liabilityList
            .filter(item => (activeTab === 'all' || item.from === 'all') && item.type !== 'frontDti')
            .reduce((sum, item) => sum + item.price, 0);
    }
    return 0;
}